export default "__VITE_ASSET__DqidXrNa__"